import React, { useState, useEffect, useContext } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { apiGetSpecificCommunityPost, apiAdminDeletePost,apiDeleteSpecificCommunityPost,apiLikeSpecificCommunityPost, apiGetUserByEmail} from '../api/api';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { IconButton, Menu, MenuItem, Snackbar } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';

import Comments from './Comments';
import { CommunityContext } from './CommunityContext';
import { ReactComponent as BlankHeart } from '../img/like-blank.svg'
import { ReactComponent as FilledHeart } from '../img/like-filled.svg'
import { ReactComponent as BackArrow } from '../img/arrow-back.svg'
import { ReactComponent as EditIcon } from '../img/edit.svg'
import { ReactComponent as DeleteIcon } from '../img/delete.svg'
import { ReactComponent as ShareIcon } from '../img/share.svg'
import './CommunityCertainPost.css'
import placeholder_profile from '../img/avatar.jpg'
import { Avatar } from '@mui/material';
const CommunityCertainPost = () => {
	const navigate = useNavigate();
	const { userData, currentPost, setCurrentPost } = useContext(CommunityContext);
	const {id} = useParams();
	const { postId } =  useParams();
	const [ creator, setCreator ] = useState();
	const [ confirmDelete, setConfirmDelete ] = useState(false);
	const [ confirmAdminDelete, setConfirmAdminDelete ] = useState(false);
	const [snackbarOpen, setSnackbarOpen] = useState(false)
	const [snackbarMessage, setSnackbarMessage] = useState("")

	const createdAtFormat = (createdAt) => {
		return createdAt.substring(11,19) + ", " + createdAt.substring(0, 10)
	}

	const init = async () => {
		(!currentPost || (currentPost._id !== id)) && retrieveCertainPost(postId);
	}

	const retrieveCertainPost = postId => {
		apiGetSpecificCommunityPost(postId)
		.then(result => {
			console.log(result.data.content);
			setCurrentPost(result.data.content);
		})
		.catch(e=>{
			console.log(e);
			e.response && alert(e.response.data.detail);
		})
	};

	const retrieveCreator = email => {
		apiGetUserByEmail(email)
		.then(result => {
			console.log('creator',result.data);
			setCreator(result.data);
		})
		.catch(e=>{
			console.log(e);
			e.response && alert(e.response.data.detail);
		})
	};

	const handleDelete = id => async e => {
			e.preventDefault();
			const result = await apiDeleteSpecificCommunityPost(id);
			result.data.status === 'deleted' && navigate(-1)
			setConfirmDelete(false)
	}

			const handleAdminDelete = id => async e => {
			e.preventDefault();
			const result = await apiAdminDeletePost(id);
			result.data.status === 'deleted by admin' && navigate(-1)
			setConfirmAdminDelete(false)
	}
    
	const handleLike = (postId, user) => async e => {
		e.preventDefault();
		let  userLiked = currentPost.userLiked;
		userLiked.push(user);
		let likesCounter = userLiked.length;
		setCurrentPost({...currentPost, userLiked, likesCounter});
		const result = await apiLikeSpecificCommunityPost(postId);
		result.data.message === 'liked' && retrieveCertainPost(postId);
	}
	
	const handleUnlike = (postId, user) => async e => {
		e.preventDefault();
		let userLiked = currentPost.userLiked.filter(item => {
				return item !== user;
		});
		let likesCounter = userLiked.length;
		setCurrentPost({...currentPost, userLiked, likesCounter});
		const result = await apiLikeSpecificCommunityPost(postId);
		result.data.message === 'unliked' && retrieveCertainPost(postId);
	}

    const sharePost = (idPost) => {
			let url = window.location.href
			navigator.clipboard.writeText(url);  
			setSnackbarMessage("Post URL copied to clipboard")
			handleSnackbarOpen()
    }

	const handleSnackbarOpen = () => {
		setSnackbarOpen(true)
		setTimeout(() => setSnackbarOpen(false), 5000)
	}

	const handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setSnackbarOpen(false);
	}

	const action = (
		<React.Fragment>
			<IconButton
				size="small"
				aria-label="close"
				color="inherit"
				onClick={handleSnackbarClose}
			>
				<CloseIcon fontSize="small" />
			</IconButton>
		</React.Fragment>
	);

	useEffect(() => {
			init()
		}, []);

	useEffect(() => {
			currentPost && retrieveCreator(currentPost.creator)
	}, [currentPost]);
    
	return(
			<>
					{ currentPost &&
							<div className="readPost readCertainPost">
									<Snackbar
										open={snackbarOpen}
										autoHideDuration={6000}
										onClose={handleSnackbarClose}
										message={snackbarMessage}
										action={action}
									/>
									<BackArrow className="backArrow" onClick={() => navigate(-1)}/>
									<Row>
											<Col className='post-content-details'>
													<Row>
															<Col className='post-avatar'>
																	<Avatar style={{cursor:"pointer"}} onClick={()=>{navigate(`/profile/${currentPost.creator}`)}} alt={creator && creator.email} src={creator && creator.image ? creator.image: placeholder_profile} />
															</Col>
															<Col>
																	<p className='createdBy'>{currentPost.username ? currentPost.username : currentPost.creator}</p>
																	<p className='publishedAt'>Published at {createdAtFormat(currentPost.createdAt)} {currentPost.isUpdated && <> &#128900; <span id="edited__tag">edited</span></>}</p>
															</Col>
															<Col className='post-buttons-details'>
																{userData.email === currentPost.creator ?
																	<>
																		<Link to={`/community/${id}/discussion/${currentPost._id}/update`}>
																			<button className='button__update'>
																				<EditIcon />
																			</button>
																		</Link>
																		<button onClick={() => setConfirmDelete(true)} 
																			data-testid="button__delete" 
																			className='button__delete' 
																			type="submit">
																			<DeleteIcon />
																		</button>
																	</>
																	:
																	((userData.isAdmin) ?
																		<>
																			<button onClick={() => setConfirmAdminDelete(true)}
																				data-testid="button__delete"
																				className='button__delete'
																				type="submit">
																				<DeleteIcon />
																			</button>
																		</>
																		:
																		null
																	)}
																<button onClick={() => sharePost(`${currentPost._id}`)}
																	className='button__share' title="share" data-testid="share-post" >
																	<ShareIcon />
																</button>
															</Col>
													</Row>
													<Row>
														{confirmDelete ?
															<Alert severity="warning">
																<AlertTitle>Warning</AlertTitle>
																This is a delete action — <strong>Are you sure want to delete this post?</strong>
																<form onSubmit={handleDelete(currentPost._id)}>
																	<button data-testid="cancel_delete"
																		className='cancel_delete'
																		onClick={() => setConfirmDelete(false)}>
																			Cancel
																	</button>
																	<button data-testid="confirm_delete"
																		className='confirm_delete'
																		type="submit">
																			Yes
																	</button>
																</form>
															</Alert>
															: null
														}
														{confirmAdminDelete ?
															<Alert severity="warning">
																<AlertTitle>Warning</AlertTitle>
																This is a delete action — <strong>Are you sure want to delete this post?</strong>
																<form onSubmit={handleAdminDelete(currentPost._id)}>
																	<button data-testid="cancel_delete"
																		className='cancel_delete'
																		onClick={() => setConfirmAdminDelete(false)}>
																			Cancel
																	</button>
																	<button data-testid="confirm_delete"
																		className='confirm_delete'
																		type="submit">
																			Yes
																	</button>
																</form>
															</Alert>
															: null
														}
													</Row>
													<p className='postTitle'>{currentPost.title}</p>
															{currentPost.attachment_url && (<div><img src={currentPost.attachment_url} className='post-image' alt="image__postingan" /></div>)}
													<p className='postContent'>{currentPost.content}</p>
											</Col>
									</Row>
									<div className='lower__button'>
									{
											currentPost.userLiked.includes(userData.email) ? 
											<div className="likes">
											<button className="unlikebutton" onClick={handleUnlike(currentPost._id, userData.email)}>
													<FilledHeart className='filledheart' />
											</button>
											<p>{currentPost.likesCounter} {currentPost.likesCounter < 2 ? 'Like': 'Likes'}</p> 
											</div>
											: 
											<div className="likes">
											<button className="likebutton" onClick={handleLike(currentPost._id, userData.email)}>
													<BlankHeart className='blankheart' />
											</button> 
											<p>{currentPost.likesCounter} {currentPost.likesCounter < 2 ? 'Like': 'Likes'}</p> 
											</div>
									}
									</div>
									<Comments postId={currentPost._id}/> 
							</div>
					}
					
			</>
			
	)
}

export default CommunityCertainPost